module.exports = __webpack_public_path__ + "public/img/export.19356ea8.png";